import styled from 'styled-components';
import Typography from 'app/ui/components/atoms/typography';
import Breadcrumb from 'app/ui/components/molecules/breadcrumb';
import GenericGradientHeader from 'app/ui/components/molecules/generic-gradient-header';
import Button from 'app/ui/components/atoms/button';
import { AccordionItem, AccordionTitle } from 'app/ui/components/molecules/accordion';
import type { Workout } from 'app/ui/components/molecules/workout-list';

export const RestDayWorkout: Workout = {
  id: 'rest-day',
  title: 'Rest Day',
  srcSet: '',
  intensity: '',
  equipment: [],
  isSaved: false,
  isCompleted: false,
};

export const StyledHeader = styled(GenericGradientHeader)`
  margin-bottom: ${({ theme }) => theme.spacing(8)};

  ${({ theme: { media } }) => `${media.medium(() => 'margin-bottom: 0;')}`};
`;

export const BreadcrumbWrapper = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing(4)};
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)};

  margin-bottom: ${({ theme }) => theme.spacing(6)};

  ${({ theme: { media, spacing } }) =>
    `${media.medium(
      () => `
        margin-top: ${spacing(8)};
        flex-wrap: nowrap;
    `,
    )}`};
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
`;

export const StyledButton = styled(Button)`
  margin: ${({ theme }) => `${theme.spacing(4)} 0 ${theme.spacing(4)} auto`};

  ${({ theme: { media } }) =>
    `${media.medium(
      () => `
        margin: 0;
    `,
    )}`};
`;

export const VideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(8)};

  ${({ theme: { media } }) =>
    media.medium(
      () => `
      display: grid;
      grid-template-columns: 1fr 1fr;
      
      & > div > video {
        width: 100%;
        height: auto;
        max-height: 23.44rem;
        object-fit: contain;
        display: block;
      }
    `,
    )};
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
`;

export const TitleWithContent = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  gap: ${({ theme: { spacing } }) => `${spacing(4)}`};

  ${({ $isOpen }) =>
    !$isOpen &&
    `svg {
      filter: invert(100%);
    }`};

  ${({ theme: { media } }) => `${media.medium(
    () => `
      max-width: 80%;
    `,
  )}
  `};
`;

export const EndContentWithIcons = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme: { spacing } }) => `${spacing(2)}`};
  margin-left: ${({ theme: { spacing } }) => `${spacing(2)}`};
`;

export const Icons = styled.div`
  ${({ theme: { spacing } }) => `
    width: ${spacing(6)};
    height: ${spacing(6)};

    svg {
      width: ${spacing(6)};
      height: ${spacing(6)};
    }
  `}
`;

export const StyledAccordionTitle = styled(AccordionTitle)<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    cursor: not-allowed;
  `}
`;

export const StyledTypography = styled(Typography)<{ $isPast?: boolean }>`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.25rem;
  ${({ theme, $isPast }) => $isPast && `color: ${theme.colors.devilsGray};`}
`;
